import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const WishlistEmailDialog = () => {
  const { pendingProduct, setPendingProduct, saveEmail } = useWishlist();
  const [email, setEmail] = useState("");

  const close = () => {
    setPendingProduct(null);
    setEmail("");
  };

  const submit = (e) => {
    e.preventDefault();
    const clean = email.trim();
    if (!clean.includes("@") || !clean.split("@")[1]?.includes(".")) {
      toast.error("Please enter a valid email address");
      return;
    }
    saveEmail(clean);
    setEmail("");
    toast.success("You'll be emailed when this piece goes on sale or runs low");
  };

  return (
    <Dialog open={!!pendingProduct} onOpenChange={(open) => !open && close()}>
      <DialogContent
        className="rounded-none border-gold/30 bg-cream sm:max-w-md"
        data-testid="wishlist-email-dialog"
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <BellRing size={18} strokeWidth={1.5} className="text-gold-accent" />
            <DialogTitle className="font-serif text-2xl text-espresso">
              Kept for you
            </DialogTitle>
          </div>
          <DialogDescription className="pt-1 text-sm leading-relaxed text-espresso/60">
            {pendingProduct?.name} is in your wishlist. Leave your email and we'll write to you the
            moment it goes on sale or is about to sell out — nothing else, ever.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="mt-2 space-y-3">
          <input
            data-testid="wishlist-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
            className="w-full border border-espresso/15 bg-transparent px-4 py-3 text-sm text-espresso outline-none transition-colors placeholder:text-espresso/35 focus:border-gold"
          />
          <div className="flex gap-3">
            <button
              type="button"
              data-testid="wishlist-email-skip"
              onClick={close}
              className="flex-1 border border-espresso/20 py-3 font-mono text-[10px] uppercase tracking-[0.25em] text-espresso/60 transition-colors hover:border-espresso/50"
            >
              Maybe Later
            </button>
            <button
              type="submit"
              data-testid="wishlist-email-save"
              className="flex-1 bg-gold py-3 font-mono text-[10px] uppercase tracking-[0.25em] text-espresso transition-all duration-300 hover:bg-gold-accent active:scale-[0.98]"
            >
              Notify Me
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default WishlistEmailDialog;
